const testimonials = [
  {
    name: "John D.",
    badge: "SEO Specialist",
    message:
      "SNILINK is an amazing service that has made my life so much easier. I no longer have to worry about sharing long and clunky URLs with my friends and colleagues. The shortened links are easy to remember and look great too!",
  },

  {
    name: "Sarah M.",
    badge: "Frontend Developer",
    message:
      "I've tried several link shortening services in the past, but SNILINK is by far the best. The links are incredibly fast and reliable, and the user interface is very easy to use. Highly recommended!",
  },
  {
    name: "Emily R.",
    badge: "UX Designer",
    message:
      "SNILINK has completely revolutionized the way I share links with my clients and customers. The shortened links are professional-looking and easy to remember, and the service has helped me streamline my workflow. I couldn't be happier with the results.",
  },
  {
    name: "David K.",
    badge: "Graphic Designer",
    message:
      "As a marketer, I've been using SNILINK for all my campaigns and it's been a game-changer. The links are incredibly easy to share and track, and the analytics feature has helped me understand my audience better than ever before.",
  },

  {
    name: "Samantha L.",
    badge: "Content Creator",
    message:
      "I was hesitant to use SNILINK at first, but I'm so glad I did. The service has saved me so much time and effort, and the links are so much easier to remember and share. I highly recommend it!",
  },
  {
    name: "Michael P.",
    badge: "Social Media Manager",
    message:
      "I've been using SNILINK for several months now and I couldn't be happier with the service. The links are always reliable and the website is very user-friendly. It's a must-have tool for anyone who shares links on a regular basis.",
  },
];
export default testimonials;
